import { render, staticRenderFns } from "./MyJourney.vue?vue&type=template&id=414ac452&scoped=true"
import script from "./MyJourney.vue?vue&type=script&lang=js"
export * from "./MyJourney.vue?vue&type=script&lang=js"
import style0 from "./MyJourney.vue?vue&type=style&index=0&id=414ac452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414ac452",
  null
  
)

export default component.exports